import { defineStore } from 'pinia'

export const useKanbanColumnsStore = defineStore('kanban-columns', {
    state: () => ({
        expandedColumns: {},
    }),

    getters: {
        isColumnExpanded: (state) => (columnId) => {
            // Por defecto todas las columnas están expandidas
            return state.expandedColumns[columnId] !== false
        },
    },

    actions: {
        toggleColumn(columnId) {
            if (this.expandedColumns[columnId] === undefined) {
                this.expandedColumns[columnId] = false
            } else {
                this.expandedColumns[columnId] = !this.expandedColumns[columnId]
            }
            this.saveState()
        },

        expandColumn(columnId) {
            this.expandedColumns[columnId] = true
            this.saveState()
        },

        collapseColumn(columnId) {
            this.expandedColumns[columnId] = false
            this.saveState()
        },

        saveState() {
            localStorage.setItem('kanban-columns-state', JSON.stringify(this.expandedColumns))
        },

        loadState() {
            const saved = localStorage.getItem('kanban-columns-state')
            if (saved) {
                try {
                    this.expandedColumns = JSON.parse(saved)
                } catch (e) {
                    console.error('Error loading kanban columns state:', e)
                }
            }
        },

        resetState() {
            this.expandedColumns = {}
            localStorage.removeItem('kanban-columns-state')
        },
    },
})
